module.exports = __webpack_public_path__ + "static/media/Ogg-Bold.ae3ed5b9.ttf";